import { createElement, FunctionComponent } from 'react'

import { AURORA_INPUT_SELECTOR } from './auroraInput'

export const AuroraInputSelectionStyles: FunctionComponent<{
  selectionTextColor: string
  selectionBackgroundColor: string
}> = ({ selectionTextColor, selectionBackgroundColor }) =>
  createElement(
    'style',
    null,
    `
    ${AURORA_INPUT_SELECTOR}::selection {
      color: ${selectionTextColor};
      background-color: ${selectionBackgroundColor};
    }
  `,
  )
